(() => {
  const campaignKey = 'mb_intro15_visit_v1';
  const closedKey = 'mb_intro15_closed_v1';
  const issuedKey = 'mb_intro15_issued_v1';
  const get = key => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
  const put = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) {} };
  function init(root) {
    if (root.dataset.ready || root.dataset.enabled !== 'true') return;
    root.dataset.ready = 'true';
    const review = false;
    // Fail closed if the review theme is accidentally published. No fake code on MAIN.
    if ((review || root.dataset.previewOnly === 'true') && window.Shopify?.theme?.role !== 'unpublished' && !window.Shopify?.designMode) return;
    const params = new URLSearchParams(location.search);
    if (['15','20'].includes(params.get('mb_intro'))) put(campaignKey, '1');
    if (!window.Shopify?.designMode && params.get('mb_intro') !== '15' && get(campaignKey) !== '1') return;
    const endpoint=root.dataset.endpoint;
    if(endpoint!=='https://mcp-gateway.direqtor.com/offers/moltonbrown/intro20')return;
    // Keep popup exclusions valid after navigation and AJAX filter/sort updates.
    function preserveCampaignUrl() {
      if (window.Shopify?.designMode || new URLSearchParams(location.search).get('mb_intro') === '15') return;
      try {
        const campaignUrl = new URL(window.location.href);
        campaignUrl.searchParams.set('mb_intro', '15');
        window.history.replaceState(window.history.state, '', campaignUrl.href);
      } catch (_) { /* The offer remains usable when history updates are unavailable. */ }
    }
    preserveCampaignUrl();
    const q = selector => root.querySelector(selector);
    const bar = q('[data-offer-bar]'), reopen = q('[data-offer-reopen]');
    const status = q('[data-offer-status]');
    let closed = get(closedKey) === '1';
    let disposed = false;
    function blockingOverlay() {
      return ['#onetrust-banner-sdk','#onetrust-pc-sdk','#CartDrawer.active','#CartDrawer.is-open'].some(selector => {
        const el = document.querySelector(selector);
        if (!el) return false;
        const s = getComputedStyle(el);
        return s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0' && el.getBoundingClientRect().height > 0;
      });
    }
    function position() {
      if (disposed) return;
      preserveCampaignUrl();
      const formReady = !!q('[data-claim-form]');
      const blocked = blockingOverlay() || !formReady;
      root.hidden = blocked;
      bar.hidden = closed;
      reopen.hidden = !closed;
      document.body.classList.toggle('mb-intro-active',!blocked && !closed);
      // Only the collapsed control avoids Shopify's preview toolbar. The open bar reaches the viewport edge.
      const previewBar = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe');
      const previewRect = previewBar?.getBoundingClientRect();
      const previewVisible = previewBar && getComputedStyle(previewBar).display !== 'none' && getComputedStyle(previewBar).visibility !== 'hidden' && previewRect.height > 0;
      const previewHeight = previewVisible ? Math.max(0, window.innerHeight - previewRect.top) : 0;
      root.style.setProperty('--mb-intro-bottom', `${previewHeight}px`);
      const v = window.visualViewport;
      const keyboard = v && root.contains(document.activeElement) ? Math.max(0,window.innerHeight-v.height-v.offsetTop) : 0;
      root.style.setProperty('--mb-intro-keyboard',`${keyboard}px`);
      document.body.style.setProperty('--mb-intro-height', `${!blocked && !closed ? bar.getBoundingClientRect().height : 0}px`);
    }
    q('[data-offer-close]').onclick = () => {closed=true;put(closedKey,'1');position();reopen.focus();};
    reopen.onclick = () => {closed=false;put(closedKey,'0');position();};
    const dialog = q('[data-offer-dialog]');
    root.querySelectorAll('[data-offer-terms]').forEach(button => { button.onclick = () => dialog.showModal(); });
    q('[data-offer-dialog-close]').onclick = () => dialog.close();
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
    const form=q('[data-claim-form]'), widget=q('[data-claim-challenge]'), submit=q('[data-claim-submit]');
    let busy=false,code=null,pendingEmail=null;
    const showStatus=text=>{status.hidden=false;status.textContent=text;position();};
    function renderCode(result){
      code=result.code;q('[data-claim-code]').textContent=code;
      q('[data-claim-expiry]').textContent='Geldig tot '+new Intl.DateTimeFormat('nl-NL',{dateStyle:'long',timeStyle:'short',timeZone:'Europe/Amsterdam'}).format(new Date(result.expiresAt));
      put(issuedKey,JSON.stringify({code:result.code,expiresAt:result.expiresAt}));
      form.reset();form.hidden=true;q('[data-claim-success]').hidden=false;q('[data-offer-heading]').textContent='Je code is klaar.';reopen.textContent='Mijn 15% kortingscode';status.hidden=true;widget.hidden=true;position();
    }
    async function issue(token){
      try{
        const response=await fetch(endpoint+'/claim',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(90000),body:JSON.stringify({email:pendingEmail,newsletterRequested:true,website:form.elements.website.value,challenge:token})});
        const result=await response.json();
        if(!response.ok){
          if(result.error==='CLAIM_UNAVAILABLE'||result.error==='CLAIM_REDEEMED')throw new Error('Je eerdere code is verlopen of gebruikt. Je ontvangt voor deze introductie geen vervangende code.');
          if(response.status===429)throw new Error('Je hebt te vaak geprobeerd. Probeer het later opnieuw.');
          throw new Error('Je code kon nog niet worden opgehaald. Probeer het later opnieuw met hetzelfde e-mailadres.');
        }
        if(!/^MB15-[A-F0-9]{32}$/.test(result.code)||!Number.isFinite(Date.parse(result.expiresAt)))throw new Error('Je code kon nog niet worden opgehaald. Probeer het later opnieuw.');
        renderCode(result);pendingEmail=null;

      }catch(error){showStatus(error.name==='TimeoutError'?'Het duurt langer dan verwacht. Probeer het opnieuw met hetzelfde e-mailadres; je ontvangt dezelfde code.':error.message);widget.reset?.();}
      finally{busy=false;submit.disabled=false;root.removeAttribute('aria-busy');}
    }
    widget.addEventListener('verified',event=>{
      const token=event.detail?.payload;
      if(busy&&token)issue(token);
    });
    widget.addEventListener('statechange',e=>{if(['error','expired'].includes(e.detail?.state)){busy=false;submit.disabled=false;root.removeAttribute('aria-busy');showStatus('De beveiligingscontrole lukte niet. Probeer het opnieuw.');}});
    form.addEventListener('submit',async e=>{
      e.preventDefault();if(busy||!form.elements.email.reportValidity()||form.elements.website.value)return;
      busy=true;submit.disabled=true;root.setAttribute('aria-busy','true');pendingEmail=form.elements.email.value.trim();
      widget.hidden=false;showStatus('Even controleren…');
      try{await Promise.race([customElements.whenDefined('altcha-widget'),new Promise((_,reject)=>setTimeout(()=>reject(new Error('Widget unavailable')),12000))]);await widget.verify();}catch{busy=false;submit.disabled=false;root.removeAttribute('aria-busy');showStatus('De beveiligingscontrole is niet beschikbaar. Probeer het later opnieuw.');}
    });
    q('[data-claim-apply]').onclick=()=>{
      if(!code)return;
      put(closedKey,'1');
      const redirect=new URL(location.href);redirect.searchParams.delete('preview_theme_id');redirect.searchParams.delete('mb_intro');redirect.searchParams.set('mb_intro','15');
      location.assign('/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(redirect.pathname+redirect.search));
    };
    q('[data-claim-change]').onclick=()=>{
      try{sessionStorage.removeItem(issuedKey);}catch(_){}
      code=null;form.hidden=false;q('[data-claim-success]').hidden=true;q('[data-offer-heading]').textContent='introductiekorting';reopen.textContent='Claim 15% korting';status.hidden=true;widget.reset?.();widget.hidden=true;position();form.elements.email.focus();
    };
    try{
      const saved=JSON.parse(get(issuedKey)||'null');
      if(saved&&/^MB15-[A-F0-9]{32}$/.test(saved.code)&&Date.parse(saved.expiresAt)>Date.now())renderCode(saved);
    }catch(_){}
    let scheduled=false;
    const update=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;position();});}};
    const observer=new MutationObserver(update);
    observer.observe(form,{childList:true,subtree:true});
    ['#onetrust-banner-sdk','#onetrust-pc-sdk','#CartDrawer'].forEach(selector=>{
      const el=document.querySelector(selector);if(el)observer.observe(el,{attributes:true,attributeFilter:['style','class','aria-hidden']});
    });
    const resized=new ResizeObserver(update);resized.observe(bar);
    window.addEventListener('resize',update);
    window.visualViewport?.addEventListener('resize',update);
    window.visualViewport?.addEventListener('scroll',update);
    document.addEventListener('OneTrustGroupsUpdated',update);
    window.addEventListener('OneTrustGroupsUpdated',update);
    // Late consent UI and app rendering are checked without reading consent cookies.
    const timer=setInterval(position,1000);
    document.addEventListener('shopify:section:unload',event=>{
      if(!event.target.contains(root))return;
      disposed=true;observer.disconnect();resized.disconnect();clearInterval(timer);
      window.removeEventListener('resize',update);window.visualViewport?.removeEventListener('resize',update);window.visualViewport?.removeEventListener('scroll',update);
      document.removeEventListener('OneTrustGroupsUpdated',update);window.removeEventListener('OneTrustGroupsUpdated',update);
      document.body.classList.remove('mb-intro-active');document.body.style.removeProperty('--mb-intro-height');
    },{once:true});
    position();
  }
  document.querySelectorAll('[data-mb-intro]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mb-intro]').forEach(init));
})();
